import { render, staticRenderFns } from "./InvoiceInboundsUploader.vue?vue&type=template&id=dae33232&"
import script from "./InvoiceInboundsUploader.vue?vue&type=script&lang=js&"
export * from "./InvoiceInboundsUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports